import { WebENV } from '@koolumbus/shared/config';

export const getStorageBucketPrefix = (env: WebENV) => {
  return `pms-${env === 'development' ? 'dev' : env === 'staging' ? 'stage' : 'prod'}`;
};
